/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import PromoteSiteNewsletterItem from './PromoteSiteNewsletterItem';

const PromoteSiteNewsletters = ({
  site,
  handleNewsletterSelect,
  handleNewsletterDeselect,
  newsletters = [],
}) => {
  if (newsletters.length === 0) {
    return null;
  }
  return (
    <>
      <div className="addon-site-header">
        <div className="addon-dive-logo">
          <img src={site.logo} alt={`${site.site_name} Logo`} />
          <span>topic newsletters</span>
        </div>
      </div>
      <div className="addon-newsletters">
        {newsletters.length > 0 ? (newsletters.map((newsletter) => (
          <PromoteSiteNewsletterItem
            key={newsletter.newsletter_schedule_id}
            newsletter={newsletter}
            handleNewsletterSelect={() => handleNewsletterSelect(site.site_id, newsletter.newsletter_schedule_id)}
            handleNewsletterDeselect={() => handleNewsletterDeselect(site.site_id, newsletter.newsletter_schedule_id)}
          />
        ))) : (
          <p style={{ marginLeft: '2.5rem' }}>No newsletters available.</p>
        )}
      </div>
    </>
  );
};

PromoteSiteNewsletters.propTypes = {
  site: PropTypes.shape({
    logo: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    site_name: PropTypes.string.isRequired,
    site_domain: PropTypes.string.isRequired,
    site_id: PropTypes.number.isRequired,
    order: PropTypes.number,
    primary: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
  }).isRequired,
  handleNewsletterSelect: PropTypes.func.isRequired,
  handleNewsletterDeselect: PropTypes.func.isRequired,
  newsletters: PropTypes.arrayOf(PropTypes.shape({
    newsletter_schedule_id: PropTypes.number.isRequired,
    public_name: PropTypes.string,
    delivery_days: PropTypes.string,
    description: PropTypes.string,
    selected: PropTypes.bool,
  })),
};

export default PromoteSiteNewsletters;
